var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrandList',{attrs:{"portal-company":_vm.portalCompany}})
}
var staticRenderFns = []

export { render, staticRenderFns }